import { Component, Input, OnInit, ViewChild } from "@angular/core";
import {
  CurrenciesService, CurrencyModel, ElementModel, ElementValueModel, Form, FormElement, MessageModalComponent,
  // ParameterTypeModel, ParameterTypesService,
  TemplateModel, TemplatesService, SupplierOfferItemSaveModel,
  // TicketProcurementCategoryModel,
  TranslationManager, ViewState, SupplierOfferItemElementSaveModel, ParameterTypesService, ParameterTypeModel
} from "src/common";
import { LocaleService } from "src/common/services/locale";
import { ElementMode, ElementViewModel, TemplateSelectComponent } from "src/views/components";
import { ParameterTypeViewModel } from "./parameter-type/parameter-type.model";


@Component({
  selector: 'app-supplier-offer-item-detail',
  templateUrl: 'supplier-offer-item-detail.component.html'
})

export class SupplierOfferItemDetailComponent implements OnInit {


  @ViewChild('messageModal') messageModal: MessageModalComponent;

  @Input('isAuctionStarted') isAuctionStarted: boolean;

  @Input() state: ViewState;
  viewState = ViewState;

  elementMode = ElementMode;

  form: Form = new Form();

  translationManager = TranslationManager;
  localeService = LocaleService;

  show: boolean = false;

  resolve: any;

  private id: number;
  requestId: number;

  formDefinition: any;
  _data: any;
  // private procurementCategoryId: number;


  currencies: CurrencyModel[];

  elements: ElementViewModel[] = [];
  requestElements: ElementViewModel[] = [];
  parameterTypes: ParameterTypeViewModel[] = [];

  parameterTypeItems: ParameterTypeModel[];

  constructor(
    // private ticketItemsService: TicketItemsService,
    // private ticketsService: TicketsService,
    private templatesService: TemplatesService,
    private currenciesService: CurrenciesService,
    private parameterTypesService: ParameterTypesService
  ) {
  }

  ngOnInit(): void {
    this.initForm();

  }

  private initForm() {
    //     this.form.elements['name'] = new FormElement();
    // this.form.elements['name'].state.mandatory = true;

    this.form.elements['creatingWayId'] = new FormElement();
    // this.form.elements['creatingWayId'].state.mandatory = true;
    //     this.form.elements['creatingWayUniqueIdentifier'] = new FormElement();

    this.form.elements['currencyId'] = new FormElement();
    this.form.elements['currencyId'].state.mandatory = true;
    this.form.elements['currencyName'] = new FormElement();

    this.form.elements['amount'] = new FormElement();
    this.form.elements['unitOfMeasure'] = new FormElement();
    this.form.elements['unitPrice'] = new FormElement();
    this.form.elements['totalPrice'] = new FormElement();

    this.form.elements['singleCost'] = new FormElement();
    this.form.elements['totalCost'] = new FormElement();
    this.form.elements['additionalCost'] = new FormElement();

    this.form.elements['creatingWayFreeForm'] = new FormElement();
    this.form.elements['creatingWayUsingTemplate'] = new FormElement();
    this.form.elements['description'] = new FormElement();
    this.form.elements['requestDescription'] = new FormElement();


    // this.form.elements['description'] = new FormElement();
    // this.form.elements['templateId'] = new FormElement();
    // this.form.elements['templateChanged'] = new FormElement();
    // this.form.elements['templateName'] = new FormElement();

    // this.form.elements['articleId'] = new FormElement();
    // this.form.elements['articleName'] = new FormElement();

    // this.form.elements['creatingWayFreeForm'] = new FormElement();
    // this.form.elements['creatingWayUsingTemplate'] = new FormElement();

    // this.form.elements['budgetAccountId'] = new FormElement();
    // this.form.elements['budgetAccountCode'] = new FormElement();
    // this.form.elements['budgetAccountBasicResourceType'] = new FormElement();
    // this.form.elements['budgetAccountCostPlace'] = new FormElement();
    // this.form.elements['budgetAccountOwner'] = new FormElement();
    // this.form.elements['budgetAccountNewBasicResourceProcurementMonth'] = new FormElement();
    // this.form.elements['budgetAccountProcurementValue'] = new FormElement();

    this.getCurrencies();
    this.getParameterTypes();
  }

  private resetFormValues() {
    // this.form.elements['name'].value = undefined;
    this.form.elements['creatingWayId'].value = undefined;
    this.form.elements['currencyId'].value = undefined;
    this.form.elements['currencyName'].value = undefined;
    // this.form.elements['articleId'].value = undefined;
    // this.form.elements['articleName'].value = undefined;
    this.form.elements['amount'].value = undefined;
    this.form.elements['additionalCost'].value = undefined;
    this.form.elements['unitOfMeasure'].value = undefined;
    this.form.elements['unitPrice'].value = undefined;
    this.form.elements['totalPrice'].value = undefined;

    this.form.elements['creatingWayFreeForm'].state.visible = false;
    this.form.elements['creatingWayUsingTemplate'].state.visible = false;
    this.form.elements['description'].value = undefined;
    this.form.elements['requestDescription'].value = undefined;

    // this.form.elements['description'].value = undefined;
    // this.form.elements['templateId'].value = undefined;
    // this.form.elements['templateName'].value = undefined;
    // this.form.elements['creatingWayFreeForm'].state.visible = false;
    // this.form.elements['creatingWayUsingTemplate'].state.visible = false;
    // this.mapBudgetAccountModelToForm(undefined);
    this.elements.splice(0, this.elements.length);
    this.parameterTypes.splice(0, this.parameterTypes.length);
  }

  private resetFormState() {

    this.form.reset();

    // this.form.elements['name'].state.mandatory = true;
    this.form.elements['creatingWayId'].state.mandatory = true;
    this.form.elements['currencyId'].state.mandatory = true;
    // this.form.elements['articleId'].state.mandatory = true;

    this.form.elements['description'].state.mandatory = false;
    // this.form.elements['templateId'].state.mandatory = false;
    //
    this.form.elements['creatingWayFreeForm'].state.visible = false;
    this.form.elements['creatingWayUsingTemplate'].state.visible = false;
  }


  private resetForm() {
    this.resetFormState();
    this.resetFormValues();
  }

  private refreshForm() {
    this.refreshFormState();
    // this.refreshFormValues();
  }

  private refreshFormState() {
    this.form.elements['creatingWayFreeForm'].state.visible = this.form.elements['creatingWayId'].value == 1;
    this.form.elements['creatingWayUsingTemplate'].state.visible = this.form.elements['creatingWayId'].value == 2;

    this.form.elements['description'].state.mandatory = this.form.elements['creatingWayId'].value == 1;
    // this.form.elements['templateId'].state.mandatory = this.form.elements['creatingWayId'].value == 2;
  }

  // private refreshFormValues() {
  //     if (this.form.elements['creatingWayId'].value == 1) {
  //         this.form.elements['templateChanged'].value = false;
  //         this.form.elements['templateId'].value = undefined;
  //         this.form.elements['templateName'].value = undefined;
  //         this.elements.splice(0, this.elements.length);
  //         this.parameterTypes.splice(0, this.parameterTypes.length);
  //     } else if (this.form.elements['creatingWayId'].value == 2) {
  //         this.form.elements['description'].value = undefined;
  //     }
  // }


  private mapFormToModel() {


    let itemValue = {};
    let paramValues = [];
    //  itemValue.id = this.id;
    // itemValue.ticketId = this.ticketId;
    // itemValue.name = this.form.elements['name'].value;


    itemValue['CurrencyId'] = this.form.elements['currencyId'].value;
    itemValue['Currency'] = +this.form.elements['currencyId'].value;
    // supplierOfferItem.quantity = this.form.elements['quantity'].value;
    itemValue['Amount'] = this.form.elements['amount'].value;
    itemValue['AdditionalCost'] = parseFloat(this.form.elements['additionalCost'].value);
    itemValue['UnitOfMeasure'] = this.form.elements['unitOfMeasure'].value;
    itemValue['UnitPrice'] = this.form.elements['unitPrice'].value;
    itemValue['TotalPrice'] = this.form.elements['totalPrice'].value;
    // supplierOfferItem.articleId = this.form.elements['articleId'].value;

    itemValue['Name'] = this._data['Name'];
    // itemValue['itemVersionId'] = this.data[0]['itemVersionId'];
    // itemValue['supplierOfferId'] = this.data[0]['supplierOfferId'];
    itemValue['RequestTicketItemId'] = this._data['RequestTicketItemId'];
    itemValue['Id'] = this._data['Id'];
    itemValue['SupplierOfferId'] = this._data['SupplierOfferId'];
    itemValue['ItemVersionId'] = this._data['ItemVersionId'] ?? 1;

    itemValue['Description'] = this.form.elements['description'].value;


    if (this.elements && this.parameterTypes) {

      for (let i = 0; i < this.elements.length; i++) {
        let p1 = JSON.parse(JSON.stringify(this.formDefinition[i]));
        let item = p1;
        for (var key in item) {
          var upper = key.charAt(0).toUpperCase() + key.slice(1);
          ;
          // check if it already wasn't uppercase
          if (upper !== key) {
            item[upper] = item[key];
            delete item[key];
          }
        }

        p1.Value = this.elements[i].getValue();
        if (!this._data['Id']) {
          p1['TicketItemElementUsedId'] = p1['ElementId'];

        }


        p1['ElementTypeUniqueIdentifier'] = p1['ElementTypeUniqueIdentifier'] ?? p1['ElementTypeName'];
        delete p1['RequestParameterType'];
        paramValues.push(p1);

      }
    }
    let result = { 'itemValue': itemValue, 'paramValues': paramValues };
    return result;
  }

  private mapModelToForm(list) {
    this.elements.splice(0, this.elements.length);
    this.requestElements.splice(0, this.requestElements.length);
    this.parameterTypes.splice(0, this.parameterTypes.length);
    if (list) {
      list.forEach((item) => {
        let elementViewModel: ElementViewModel = new ElementViewModel();
        elementViewModel.element = new ElementModel();
        elementViewModel.element.id = item['elementId'];
        elementViewModel.element.type = item['elementTypeName'] ?? item['elementTypeUniqueIdentifier'];

        elementViewModel.element['value'] = item['value'];

        elementViewModel.element.data = {
          'name': item['elementName'],
          'isMandatory': item['isMandatory'],
          'definition': item['definition']
        }

        this.elements.push(elementViewModel);

        let elementViewModel1: ElementViewModel = new ElementViewModel();
        elementViewModel1.element = new ElementModel();
        elementViewModel1.element.id = item['elementId'];
        elementViewModel1.element.type = item['elementTypeName'] ?? item['elementTypeUniqueIdentifier'];
        elementViewModel1.element['value'] = item['requestValue'];
        elementViewModel1.element.data = {
          'name': item['elementName'],
          'isMandatory': item['isMandatory'],
          'definition': item['definition']
        }
        this.requestElements.push(elementViewModel1);

        let paramTypeViewModel = new ParameterTypeViewModel();
        paramTypeViewModel.value = item['requestParameterType'];
        paramTypeViewModel.options = this.parameterTypeItems;
        this.parameterTypes.push(paramTypeViewModel);

      });
    }
  }


  private getCurrencies(): Promise<void> {
    return new Promise((resolve) => {
      this.currenciesService.getAll().then((items: CurrencyModel[]) => {
        this.currencies = items;
        resolve();
      })
    })
  }

  submit() {
    let valid = this.isFormValid();

    if (valid) {
      let model = this.mapFormToModel();
      this.show = false;
      if (this.resolve) {
        this.resolve(model);
      }
    }

  }

  private isFormValid(): boolean {
    let isValid: boolean = this.form.isValid();
    let areElementsValid: boolean = true;
    let areFormValid: boolean = true;
    let areParameterTypesValid: boolean = true;

    this.elements.forEach((item: ElementViewModel) => {
      areElementsValid = item.isValueValid() && areElementsValid;
    })

    Object.keys(this.form.elements).forEach((k1) => {
      areFormValid = this.form.elements[k1].isValid() && areFormValid;
    });

    return isValid && areElementsValid && areFormValid && areParameterTypesValid;
  }

  close() {
    this.show = false;
    if (this.resolve) {
      this.resolve();
    }
  }


  showModal(formDefinitionParam, supplierOfferItem): Promise<any> {

    this.resetForm();
    this._data = {};

    if (formDefinitionParam) {
      this.formDefinition = formDefinitionParam['data'];
      this._data['Name'] = this.formDefinition[0]['ticketItemName'];
      this._data['RequestTicketItemId'] = this.formDefinition[0]['requestTicketItemId'];
    }
    else if (supplierOfferItem) {
      this._data = {};
      this._data['Name'] = supplierOfferItem['name'];
      this._data['RequestTicketItemId'] = supplierOfferItem['requestTicketItemId'];
      this._data['Id'] = supplierOfferItem['id'];
      this._data['SupplierOfferId'] = supplierOfferItem['supplierOfferId'];
      this._data['ItemVersionId'] = supplierOfferItem['itemVersionId'];

      this.form.elements['amount'].value = supplierOfferItem.amount;
      this.form.elements['unitOfMeasure'].value = supplierOfferItem.unitOfMeasure;
      this.form.elements['unitPrice'].value = supplierOfferItem.unitPrice;
      this.form.elements['totalPrice'].value = supplierOfferItem.totalPrice;
      this.form.elements['additionalCost'].value = supplierOfferItem.additionalCost;
      this.form.elements['currencyId'].value = supplierOfferItem.currency;
      this.form.elements['currencyName'].value = supplierOfferItem.currencyName;
      // this.form.elements['currencyName'] = supplierOfferItem.currencyName;
      // SKLANJAM 20.02.2023 derrad kada je state EDIT
      //  if(this.state == this.viewState.Details){
      this.form.elements['description'].value = supplierOfferItem.description;

      this.form.elements['requestDescription'].value = supplierOfferItem.requestDescription;
      this.form.elements['creatingWayId'].value = supplierOfferItem.creatingWayId;
      this.refreshForm();

      let a1 = supplierOfferItem['params'];
      if (a1) {
        this.formDefinition = a1.map(a2 => {
          let a3 = {};
          a3['elementId'] = a2['value']?.['elementUsedId'];
          a3['id'] = a2['value']?.['elementUsedId'];
          a3['elementTypeUniqueIdentifier'] = a2['elementTypeUniqueIdentifier'];
          a3['elementName'] = a2['elementName'];
          a3['elementTypeId'] = a2['elementTypeId'];
          a3['isMandatory'] = a2['isMandatory'];
          a3['value'] = a2['value']?.['value'];
          a3['requestParameterType'] = a2['requestParameterType']?.['uniqueIdentifier'];
          // derrad 22.03.2023 zahtev ako je edit da bude popunjen
          // derrad 06.04.2023 ubacio i && a3['requestParameterType'] =='Eliminatory'
          if (a3['isMandatory'] && this.state === this.viewState.Edit && a3['requestParameterType'] == 'Eliminatory' && (a3['value'] === null || a3['value'] === undefined) && (a3['elementTypeUniqueIdentifier'] !== 'SingleSelection')) {
            a3['value'] = a2['requestValue']?.['value'];
          }
          a3['requestValue'] = a2['requestValue']?.['value'];

          if (a3['elementTypeUniqueIdentifier'] == 'SingleSelection') {
            // derrad 22.03.2023 zahtev ako je edit da bude popunjen posebno za ovu selekciju
            // derrad 06.04.2023 ubacio i && a3['requestParameterType'] =='Eliminatory'
            if (a3['isMandatory'] && this.state === this.viewState.Edit && a3['requestParameterType'] == 'Eliminatory' && (a2['value']?.['elementDefinitionSelectionUsedId'] === null || a2['value']?.['elementDefinitionSelectionUsedId'] === undefined)) {
              a3['value'] = a2['requestValue']?.['elementDefinitionSelectionUsedId']; // a2['value']?.['elementDefinitionSelectionUsedId'];
              a3['requestValue'] = a2['requestValue']?.['elementDefinitionSelectionUsedId'];

            } else {
              a3['value'] = a2['value']?.['elementDefinitionSelectionUsedId'];
              a3['requestValue'] = a2['requestValue']?.['elementDefinitionSelectionUsedId'];
            }

          }

          a3['ticketItemElementUsedId'] = a2['ticketItemElementUsedId'];
          a3['requestParameterType'] = a2['requestParameterType']?.['id'];
          a3['definition'] = a2['requestDropDown'];
          return a3;
        });
      } else {
        // derrad 01.02.20233 - prikazivao na slobodnoj formi sve, kada si pre nje bio u šablon formi
        this.formDefinition = undefined;
      }
    }
    this.mapModelToForm(this.formDefinition);

    this.show = true;

    return new Promise((resolve) => {
      this.resolve = resolve;
    })
  }

  // derrad 15.05.2023 promena cene računa vrednost
  changeUnitPrice(val) {
    var kolic = this.form.elements['amount'].value ?? 0;
    var trosak = this.form.elements['additionalCost'].value ?? 0;
    if (val) {
      var vrednost = (val * kolic) + trosak;
      this.form.elements['totalPrice'].value = vrednost;

    }
  }
  changeAdditionalCost(val) {
    var kolic = this.form.elements['amount'].value ?? 0;
    var cena = this.form.elements['unitPrice'].value ?? 0;
    if (val) {
      var vrednost = (cena * kolic) + val;
      this.form.elements['totalPrice'].value = vrednost;

    }
  }

  getParameterTypes(): Promise<void> {
    return new Promise<void>((resolve) => {
      this.parameterTypesService.getAll().then((items: ParameterTypeModel[]) => {
        this.parameterTypeItems = items;
        resolve();
      })
    })
  }
}
